import React from 'react';
import { checkValue } from 'utils';
import { RecordFieldWrapper } from '../style';

function RecordField({ label, value }) {
  return (
    <RecordFieldWrapper>
      <div className="record__key">{label}:</div>
      <div className="record__value">{checkValue(value)}</div>
    </RecordFieldWrapper>
  );
}

export { RecordField };
